const MONTHLY_PHONE_CONSULTATION_NOTE_TITLES = [
  "RPM Monthly Phone Consultation",
  "CCM Monthly Phone Consultation"
];

function capitalizeWord(value) {
  const text = String(value || "").trim();
  if (!text) {
    return "";
  }
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

function capitalizeName(name) {
  return String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(capitalizeWord)
    .join(" ");
}

function formatPerformerDisplayName(name) {
  if (!name || name === "-") {
    return name;
  }
  return name
    .split(",")
    .map((part) => capitalizeName(part.trim()))
    .filter(Boolean)
    .join(", ");
}

function normalizeNoteTitle(noteTitle) {
  if (noteTitle == null || noteTitle === false || noteTitle === true) {
    return "";
  }
  return String(noteTitle).trim();
}

function isMonthlyPhoneConsultationSession(session) {
  if (!session) {
    return false;
  }

  if (session.hadPhoneConsultation === true) {
    return true;
  }

  const title = normalizeNoteTitle(session.noteTitle);
  return MONTHLY_PHONE_CONSULTATION_NOTE_TITLES.includes(title);
}

function getMonthlyPhoneConsultationPerformerName(session) {
  if (!isMonthlyPhoneConsultationSession(session)) {
    return "-";
  }

  const careProvider = session.careProvider;
  if (careProvider && typeof careProvider !== "string") {
    const name = [careProvider.lname, careProvider.fname]
      .filter(Boolean)
      .map(capitalizeWord)
      .join(" ")
      .trim();
    if (name) {
      return name;
    }
  }

  const title = normalizeNoteTitle(session.noteTitle);
  return title || "-";
}

function getPatientMonthlyPhoneConsultationBy(patientRow) {
  const fromApi = (patientRow?.monthlyPhoneConsultationBy || "").trim();
  if (fromApi) {
    return formatPerformerDisplayName(fromApi);
  }

  const logs = patientRow?.ccmLogs;
  if (!Array.isArray(logs) || logs.length === 0) {
    return "-";
  }

  const performers = [];
  const seen = new Set();

  logs.forEach((session) => {
    const name = getMonthlyPhoneConsultationPerformerName(session);
    if (name && name !== "-" && !seen.has(name)) {
      seen.add(name);
      performers.push(name);
    }
  });

  return performers.length > 0 ? performers.join(", ") : "-";
}

module.exports = {
  getMonthlyPhoneConsultationPerformerName,
  getPatientMonthlyPhoneConsultationBy,
  isMonthlyPhoneConsultationSession,
};
